import moment from "moment";
export default {
  dateFormat(value, format = "MM/DD/YYYY hh:mm A") {
    return moment(value).format(format);
  },
  currentDate(format = "YYYY-MM-DD HH:mm:ss") {
    return moment().format(format);
  },
  currentYear(){
    return moment().format('YYYY');
  },
  currencyFormat(num, symbol, isEur = false) {

    if (isEur) {
      return (
        num
        .toFixed(2) // always two decimal digits
        .replace('.', ',') // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
      ) // use . as a separator
    }

    return (symbol ? symbol+" " : "") + (
      num
      .toFixed(2) // always two decimal digits
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    ) // use . as a separator
    
  },
  addProtocol($url) {

    if ($url.indexOf("://") === -1) {
      return `http://${$url}`;
    }

    return $url;
  },
  objectToQuerystring (obj) {
    return Object.keys(obj).reduce(function (str, key, i) {
      var delimiter, val;
      delimiter = (i === 0) ? '?' : '&';
      key = encodeURIComponent(key);
      val = encodeURIComponent(obj[key]);
      return [str, delimiter, key, '=', val].join('');
    }, '');
  }
};